import React from "react";
import { Pagination } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

export default function MyPagination({
  paginationDetails,
  setPaginationDetails = () => {},
  totalCount = 12,
  darkPagination = false,
}) {
  const { limit = 10, page = 1 } = paginationDetails ?? {};
  const totalPage = Math.ceil(totalCount / limit);

  const [searchParams, setSearchParams] = useSearchParams();

  const handlePage = (page) => {
    if (page < 1 || page > totalPage) return;
    setSearchParams(
      (prev) => {
        prev.set("page", page);
        return prev;
      },
      { replace: true }
    );

    setPaginationDetails((prev) => {
      return {
        ...prev,
        page,
      };
    });
  };

  return (
    <>
      <Pagination className={darkPagination ? "darkPagination" : ""}>
        <Pagination.Prev onClick={() => handlePage(page - 1)} />
        {Array.from({ length: totalPage || 1 }).map((_, i) => (
          <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => handlePage(i + 1)}>
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => handlePage(page + 1)} />
      </Pagination>
    </>
  );
}
